import React from 'react';

import type { TableColumn, TableRow as TableRowType } from '../types';

import { DefaultCell } from './DefaultCell';

interface TableRowProps<T> {
  row: T;
  columns: TableColumn<T>[];
  rowIndex: number;
  onRowClick?: (row: T, index: number) => void;
  enableStickyColumns?: boolean;
}

export const TableRow = <T,>({
  row,
  columns,
  rowIndex,
  onRowClick,
  enableStickyColumns = false
}: TableRowProps<T>) => (
  <div
    className={`flex ${
      onRowClick ? 'hover:bg-gray-50 cursor-pointer transition-colors' : ''
    }`}
    onClick={() => onRowClick?.(row, rowIndex)}>
    {columns.map(column => (
      <div
        key={column.key}
        className={`${column.width || 'flex-1'} ${
          enableStickyColumns && column.width ? 'flex-shrink-0' : ''
        } h-12 px-4 py-2 bg-white border-r border-b border-l border-[#EEEFF2] flex items-center ${
          enableStickyColumns && column.sticky === 'right'
            ? 'sticky right-0 bg-white border-l border-[#EEEFF2] shadow-[-4px_0_8px_-2px_rgba(0,0,0,0.1)] z-10'
            : enableStickyColumns && column.sticky === 'left'
            ? 'sticky left-0 bg-white border-r border-[#EEEFF2] shadow-[4px_0_8px_-2px_rgba(0,0,0,0.1)] z-10'
            : ''
        }`}>
        {column.render ? (
          column.render((row as TableRowType)[column.key], row, rowIndex)
        ) : (
          <DefaultCell value={(row as TableRowType)[column.key]} />
        )}
      </div>
    ))}
  </div>
);
